<div class="overview-item">
  <div class="d-flex align-items-center">
    <div class="w-100">
      <div class="title">{{ 'INVOICE.TOTAL_NUMBER_OF_INVOICES' | translate }}</div>
      <div class="amount">{{ number }}</div>
    </div>
  </div>
</div>
